import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "font-medium mt-5 mb-2 text-[12px]" }, "Ingrese los datos", -1)
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Selector = _resolveComponent("Selector")!
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_openBlock(), _createBlock(_component_NewModal, {
    title: "Crear nueva cuenta",
    class: "p-8",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = (e) => _ctx.$emit('update:visible', e))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Selector, {
          label: "Asociar accionista",
          class: "w-full",
          model: _ctx.shareholderSelected,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shareholderSelected) = $event)),
          "has-error": _ctx.typeActionFieldHasError,
          "error-message": "Es necesario indicar el Tipo de movimiento",
          items: _ctx.shareholderItems,
          values: _ctx.shareholderValues
        }, null, 8, ["model", "has-error", "items", "values"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "success btn ml-auto",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.registerNewAccount && _ctx.registerNewAccount(...args))),
        disabled: _ctx.formHasError
      }, " Agregar cuenta ", 8, _hoisted_3)
    ]),
    _: 1
  }, 8, ["visible"]))
}